// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"13e67303","952":"e211eef4"}[chunkId] + ".chunk.js";
};